import { Map } from 'immutable';
import BaseObject from "@models/BaseObject";
import { ID, ReduxAction } from '@app/types';
import { AppState } from '@reducers/rootReducer';


class Import extends BaseObject {
  uuid: string;
  groupID: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';

  constructor(props) {
    super(props);
    this.uuid = props.uuid;
    this.groupID = String(props.groupID);
    this.status = props.status;
  }
}

export type ImportsState = Map<ID, Import>;

export const selectImportStatus = (importUUID: string) => (state: AppState) => state.data.imports.get(importUUID)?.status;

export function ImportsReducer(state: ImportsState = Map<ID, Import>(), { type, payload }: ReduxAction) {
  switch (type) {
    case 'FETCH_ALL_GROUPS_SUCCEEDED':
      const importingGroups = payload.response?.filter(group => group.bulk_import?.status && group.bulk_import.status !== 'completed');

      if (!importingGroups || importingGroups.length === 0) {
        return state;
      }

      return importingGroups.reduce((importsState, group) => {
        const uuid = group.bulk_import.uuid;
        return importsState.set(uuid, new Import({
          uuid,
          groupID: group.id,
          status: group.bulk_import.status,
        }));
      }, state);

    case 'FETCH_IMPORT_STATUS_SUCCEEDED':
      return state.set(payload.uuid, new Import({
        uuid: payload.uuid,
        groupID: String(payload.import_group),
        status: payload.status,
      }));

    default:
      return state;
  }
}

